export class DriverPouchEntity {
  id?: number
  amount?: number
  driverId?: number
  driverFullName?: string | null
  maxAmountLimit?: number | null
  pouchDefaultMaxAmountLimit?: number
  defaultMaxAmountLimit?: number
  isDriverHalted?: boolean
}
